import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSummary from './reducers/summary.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SummaryEffects } from './effects/summary.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('Summary', fromSummary.reducer),
    StoreModule.forFeature('Preferences', fromSummary.preferencesReducer),
    StoreModule.forFeature('SummaryDetail', fromSummary.summaryDetailReducer),
    EffectsModule.forFeature([SummaryEffects])
  ]
})
export class SummaryModule { }
